<div class="w-100 d-flex">
    <sl-datepicker class="flex-grow-1" [control]="control" [placeholderKey]="placeholderKey" (input)="onChange()" (blur)="onBlur()" />
    <mat-form-field class="flex-grow-1 ml-2">
        <input matInput (input)="onChange()" (blur)="onBlur()" [formControl]="timeControl" maxLength="5" />
    </mat-form-field>
</div>
